<template lang="pug">
.post-header
  .post-header__top-line.post-meta-group
    a.post-meta-group.--base-color(
      :href="postUrl"
    )
      post-meta-item.post-datetime(
        fade
        small-caps
        italic
        underline
        :title="postedOnDate"
        :text="relativePostedOnDate"
      )
      post-meta-item.post-readtime(
        fade
        small-caps
        italic
        :title="`${wordCount} words`"
        :text="timeToRead"
      )

    post-meta-group
      post-meta-group
        post-meta-item.post-tribute-count(
          fade
          underline
          icon="❤"
          :text="`${tributesCount}`"
        )

      post-meta-group.post-admin(
        v-if="canAdmin"
        menu
      )
        report-button.post-meta-item.post-admin-item(
          v-if="canReport"
          :post-id="post.id"
        )
        edit-button.post-meta-item.post-admin-item(
          v-if="canEdit"
          :post-id="post.id"
        )

  post-title(
    :post="post",
    subtitle
  )

  post-tags(
    v-if="!hideTags",
    :tags="tags",
  )

  post-author(
    v-if="!hideAuthor",
    :author="author"
  )
</template>

<script>
import PostResourceMixin from '@/mixins/postResource'
import DateHelpersMixin from '@/mixins/dateHelpers'
import EditButton from '@/components/edit-button'
import ReportButton from '@/components/report-button'
import PostAuthor from '@/components/post/post-author'
import PostMetaGroup from '@/components/post/post-meta-group'
import PostMetaItem from '@/components/post/post-meta-item'
import PostTags from '@/components/post/post-tags'
import PostTitle from '@/components/post/post-title'

export default {
  name: 'post-header',
  components: {
    EditButton,
    PostAuthor,
    PostMetaGroup,
    PostMetaItem,
    PostTags,
    PostTitle,
    ReportButton,
  },
  mixins: [DateHelpersMixin, PostResourceMixin],
  props: {
    hideTags: {
      type: Boolean,
      default: false,
    },
    hideAuthor: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    postUrl() {
      const { href } = this.$router.resolve({
        name: 'postById',
        params: { id: this.post.id },
      })
      return href
    },
    postedOnDate() {
      return this.formatDate(this.post.createdAt, 'PPPPpppp')
    },
    relativePostedOnDate() {
      return this.formatRelativeToNow(this.post.createdAt)
    },
    tributesCount() {
      return this.tributes.length
    },
    rawContent() {
      return `${this.post.title} ${this.post.subtitle ||
        ''} ${this.post.sections.reduce((acc, s) => {
        acc += ' ' + typeof s === 'string' ? s : s.content || ''
        return acc
      }, '')}`
    },
    wordCount() {
      return (
        this.rawContent.replace(/['";:,.?¿\-!¡]+/g, '').match(/\S+/g) || []
      ).length
    },
    timeToRead() {
      const wpm = 200
      const estimate = this.wordCount / wpm
      const minutes = Math.round(estimate)

      return minutes < 1 ? '< 1 min read' : `${minutes} min read`
    },
    canAdmin() {
      return this.$currentUser
    },
    canReport() {
      return this.$currentUser
    },
    canEdit() {
      return this.isAuthor || this.$currentUser.isAdmin
    },
  },
}
</script>

<style lang="sass">
.post-header
  margin-top: 4rem

.post-header__top-line  
  margin-bottom: 0.5rem

.post-meta-group
  .report-button,
  .edit-button
    margin-bottom: 0

.post-header
  .post-title,
  .post-subtitle
    font-family: var(--serif-fonts)
</style>